import React from "react";

export default function DashboardIcon({ className }) {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={{ ...className }}
      >
        <g clipPath="url(#clip0_505_1315)">
          <path
            d="M7.75 20.2506C8.85457 20.2506 9.75 19.3552 9.75 18.2506V16.2506C9.75 15.146 10.6454 14.2506 11.75 14.2506H12.25C13.3546 14.2506 14.25 15.146 14.25 16.2506V18.2506C14.25 19.3552 15.1454 20.2506 16.25 20.2506H18.25C19.3546 20.2506 20.25 19.3552 20.25 18.2506V11.2506C20.2501 11.1521 20.2307 11.0545 20.1931 10.9635C20.1555 10.8724 20.1003 10.7897 20.0306 10.72L12.5306 3.21996C12.461 3.15023 12.3783 3.09491 12.2872 3.05717C12.1962 3.01943 12.0986 3 12 3C11.9014 3 11.8038 3.01943 11.7128 3.05717C11.6217 3.09491 11.539 3.15023 11.4694 3.21996L3.96938 10.72C3.89975 10.7897 3.84454 10.8724 3.8069 10.9635C3.76926 11.0545 3.74992 11.1521 3.75 11.2506V18.2506C3.75 19.3552 4.64543 20.2506 5.75 20.2506H7.75Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_505_1315">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
}
